import { render } from "./ProductSurvey.vue?vue&type=template&id=74f1d188"
import script from "./ProductSurvey.vue?vue&type=script&lang=js"
export * from "./ProductSurvey.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\survey_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__